import { useState } from "react";

export default function AddTeamMember() {
  const [selectedColor, setSelectedColor] = useState(null);
  const colors = [
    "#93c5fd",
    "#a5b4fc",
    "#c4b5fd",
    "#f9a8d4",
    "#fca5a5",
    "#fcd34d",
    "#fde68a",
    "#bbf7d0",
    "#86efac",
    "#6ee7b7",
  ];

  return (
    <div className="flex flex-col h-screen container mx-auto">
      {/* Header */}
      <header className="flex justify-between items-center px-8 py-4 border-b bg-white sticky top-0 z-10">
        <h1 className="text-2xl font-bold">Add team member</h1>
        <div className="space-x-2">
          <button className="px-4 py-2 border rounded-md">Close</button>
          <button className="px-4 py-2 bg-black text-white rounded-md">
            Add
          </button>
        </div>
      </header>

      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar */}
        <aside className="w-64 border-r bg-gray-50 p-6 overflow-y-auto sticky top-16 h-[calc(100vh-64px)]">
          <nav className="space-y-6 text-sm">
            <div>
              <h2 className="text-lg font-semibold mb-2">Personal</h2>
              <ul className="space-y-2">
                <li className="font-medium text-indigo-600">Profile</li>
                <li className="text-gray-600">Addresses</li>
                <li className="text-gray-600">Emergency contacts</li>
              </ul>
            </div>
            <div>
              <h2 className="text-lg font-semibold mb-2">Workspace</h2>
              <ul className="space-y-2">
                <li className="text-gray-600">Services</li>
                <li className="text-gray-600">Locations</li>
                <li className="text-gray-600">Settings</li>
              </ul>
            </div>
            <div>
              <h2 className="text-lg font-semibold mb-2">Pay</h2>
              <ul className="space-y-2">
                <li className="text-gray-600">Wages and timesheets</li>
                <li className="text-gray-600">Commissions</li>
                <li className="text-gray-600">Pay runs</li>
              </ul>
            </div>
          </nav>
        </aside>

        {/* Main Form Content */}
        <main className="flex-1 px-12 py-8 overflow-y-auto">
          <div className="max-w-4xl">
            {/* Profile Section */}
            <section className="mb-12">
              <h2 className="text-lg font-semibold mb-2">Profile</h2>
              <p className="text-sm text-gray-500 mb-6">
                Manage your team member’s personal profile
              </p>

              <div className="grid grid-cols-2 gap-6">
                <input
                  type="text"
                  placeholder="First name *"
                  className="border p-3 rounded-md"
                />
                <input
                  type="text"
                  placeholder="Last name"
                  className="border p-3 rounded-md"
                />
                <input
                  type="email"
                  placeholder="Email *"
                  className="border p-3 rounded-md"
                />

                <div className="flex space-x-2">
                  <select className="border p-3 rounded-md">
                    <option>+64</option>
                    <option>+61</option>
                    <option>+1</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Phone number"
                    className="border p-3 rounded-md flex-1"
                  />
                </div>

                <div className="flex space-x-2">
                  <select className="border p-3 rounded-md">
                    <option>+64</option>
                    <option>+61</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Additional phone number"
                    className="border p-3 rounded-md flex-1"
                  />
                </div>

                <select className="border p-3 rounded-md">
                  <option>Select country</option>
                  <option>New Zealand</option>
                  <option>Australia</option>
                </select>

                <div className="flex space-x-2">
                  <input
                    type="text"
                    placeholder="Birthday (Day & Month)"
                    className="border p-3 rounded-md flex-1"
                  />
                  <input
                    type="text"
                    placeholder="Year"
                    className="border p-3 rounded-md w-28"
                  />
                </div>

                <div className="col-span-2">
                  <label className="text-sm block mb-2">Calendar color</label>
                  <div className="flex flex-wrap gap-2">
                    {colors.map((c, idx) => (
                      <button
                        key={idx}
                        onClick={() => setSelectedColor(c)}
                        style={{ backgroundColor: c }}
                        className={`w-7 h-7 rounded-full border-2 ${
                          selectedColor === c ? "border-black" : "border-white"
                        }`}
                      ></button>
                    ))}
                  </div>
                </div>

                <input
                  type="text"
                  placeholder="Job title"
                  className="border p-3 rounded-md col-span-2"
                />
              </div>
            </section>

            {/* Work Details */}
            <section>
              <h2 className="text-lg font-semibold mb-2">Work details</h2>
              <p className="text-sm text-gray-500 mb-6">
                Manage your team member’s start date, and employment details
              </p>

              <div className="grid grid-cols-2 gap-6">
                <input type="date" className="border p-3 rounded-md" />
                <input type="date" className="border p-3 rounded-md" />
                <select className="border p-3 rounded-md">
                  <option>Employment type</option>
                  <option>Full-time</option>
                  <option>Part-time</option>
                  <option>Contract</option>
                </select>
                <input
                  type="text"
                  placeholder="Team member ID"
                  className="border p-3 rounded-md"
                />
                <textarea
                  placeholder="Notes"
                  rows="3"
                  className="border p-3 rounded-md col-span-2"
                ></textarea>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
